import { Modal } from "./modal";

export const EditLimit = { Modal };
